import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtohublicab() {



    const cardData = {




keyword: "Belgaum to Hubli Cab",

headingDescription: "Belgaum Taxi Service provides reliable and comfortable Belgaum to Hubli cab services for business travel, family trips, medical visits, airport transfers, railway station transfers, and outstation journeys. Whether you need a one-way taxi or a round-trip cab from Belgaum to Hubli, we offer safe and affordable travel with professional drivers and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cab options according to your travel requirements. Our services include doorstep pickup, flexible travel timings, transparent pricing, easy booking, and 24/7 customer support to ensure a smooth journey. Belgaum Taxi Service connects passengers between Belgaum and Hubli for corporate visits, educational travel, shopping trips, healthcare requirements, and personal transportation with comfortable and hassle-free cab solutions.",

topPlaces: [
  {
    title: "Hubballi Airport",
    description: "Hubballi Airport is an important travel hub in North Karnataka. Belgaum to Hubli airport cab services provide convenient pickup and drop facilities for business and leisure travelers."
  },
  {
    title: "Unkal Lake",
    description: "Unkal Lake is a popular tourist attraction in Hubli known for its peaceful surroundings, boating, and scenic views, making it a preferred sightseeing destination."
  },
  {
    title: "Chandramouleshwara Temple",
    description: "Chandramouleshwara Temple is a historic architectural landmark in Hubli known for its beautiful stone carvings and cultural importance."
  },
  {
    title: "KIMS Hubli",
    description: "KIMS Hubli is a major healthcare institution attracting patients and visitors from nearby cities. Cab services provide comfortable travel for medical requirements."
  },
  {
    title: "Dharwad",
    description: "Dharwad is a nearby educational and cultural city known for universities, institutions, and traditional heritage. It is a frequent travel destination from Hubli."
  },
  {
    title: "Bangalore",
    description: "Bangalore is a major IT and business hub in Karnataka. Travelers often prefer comfortable cabs for long-distance journeys between Hubli and Bangalore."
  },
  {
    title: "Goa",
    description: "Goa is a popular holiday destination known for beaches, resorts, and sightseeing attractions. Private cabs offer a convenient travel option from Hubli and nearby cities."
  },
  {
    title: "Pune",
    description: "Pune is a leading IT and commercial city in Maharashtra. Cab services are preferred for corporate travel, family visits, and interstate journeys."
  },
  {
    title: "Mumbai",
    description: "Mumbai is India's financial capital with major airports, business districts, and tourist attractions. Comfortable outstation cabs connect travelers from Karnataka to Mumbai."
  },
  {
    title: "Hampi",
    description: "Hampi is a UNESCO World Heritage destination famous for ancient ruins, temples, and historical monuments, making it a popular tourist trip from North Karnataka."
  }
],




"services": [
  {
    "name": "Belgaum to Hubli Cab",
    "description": "Book Belgaum to Hubli Cab for safe, comfortable, and reliable intercity travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova Crysta, and SUV cabs for business trips, family travel, airport transfers, and personal journeys with flexible one way and round trip options."
  },
  {
    "name": "Belgaum to Hubli Taxi",
    "description": "Choose Belgaum to Hubli Taxi for convenient and affordable transportation with experienced drivers, clean vehicles, transparent pricing, and doorstep pickup services. Enjoy a smooth journey between Belgaum and Hubli with reliable cab solutions available for all travel needs."
  },
  {
    "name": "Belgaum to Hubli Cab Service",
    "description": "Our Belgaum to Hubli Cab Service provides comfortable AC cabs, professional chauffeurs, fixed fares, and timely pickup facilities. Travel hassle-free with premium vehicles suitable for corporate travel, family trips, airport rides, and daily transportation."
  },
  {
    "name": "Belgaum to Hubli Taxi Service",
    "description": "Book Belgaum to Hubli Taxi Service for safe and convenient travel with experienced drivers and multiple vehicle options. Get reliable transportation for personal trips, business travel, local transfers, and outstation journeys at affordable rates."
  },
  {
    "name": "Belgaum to Hubli One Way Cab",
    "description": "Hire Belgaum to Hubli One Way Cab for economical single-trip travel without return charges. Enjoy fixed pricing, comfortable seating, AC vehicles, and professional chauffeur services for a smooth and stress-free journey."
  },
  {
    "name": "Belgaum to Hubli Cab Booking",
    "description": "Complete Belgaum to Hubli Cab Booking online with easy reservations, instant confirmation, flexible pickup locations, and multiple cab choices. Get reliable taxi services with transparent fares and 24x7 customer assistance."
  },
  {
    "name": "Belgaum to Hubli Car Rental",
    "description": "Choose Belgaum to Hubli Car Rental services for comfortable private travel with driver options. Select from Sedan, SUV, Ertiga, and Innova Crysta vehicles for business trips, family tours, and personal transportation."
  },
  {
    "name": "Belgaum to Hubli Outstation Cab",
    "description": "Book Belgaum to Hubli Outstation Cab for safe and comfortable long-distance travel. Our outstation taxi services offer clean AC vehicles, experienced chauffeurs, affordable packages, and flexible travel options."
  },
  {
    "name": "Belgaum to Hubli Airport Cab",
    "description": "Reserve Belgaum to Hubli Airport Cab for punctual airport pickup and drop services. Travel comfortably with professional drivers, spacious vehicles, and reliable airport transfer solutions."
  },
  {
    "name": "Belgaum to Hubli Airport Taxi",
    "description": "Choose Belgaum to Hubli Airport Taxi for convenient airport transportation with doorstep pickup, timely service, and comfortable AC cars. Ideal for business travelers, families, and individual passengers."
  },
  {
    "name": "Belgaum to Hubli Innova Crysta Cab",
    "description": "Book Belgaum to Hubli Innova Crysta Cab for premium travel comfort with spacious seating, luxury interiors, and experienced chauffeurs. Perfect for family trips, corporate journeys, airport transfers, and group travel."
  },
  {
    "name": "Belgaum to Hubli Ertiga Cab",
    "description": "Travel with Belgaum to Hubli Ertiga Cab offering spacious 6 to 7 seater comfort, affordable pricing, and reliable chauffeur services. Ideal for family travel, group journeys, and outstation transportation."
  },
  {
    "name": "Belgaum to Hubli Sedan Cab",
    "description": "Book Belgaum to Hubli Sedan Cab for economical and comfortable travel with clean AC cars and professional drivers. Suitable for business trips, personal rides, airport transfers, and quick city-to-city travel."
  },
  {
    "name": "Belgaum to Hubli Round Trip Cab",
    "description": "Hire Belgaum to Hubli Round Trip Cab for flexible return journeys with affordable packages and experienced chauffeurs. Enjoy convenient transportation for sightseeing, business meetings, and family travel."
  },
  {
    "name": "Belgaum to Hubli Private Taxi",
    "description": "Choose Belgaum to Hubli Private Taxi for exclusive chauffeur-driven travel with privacy, comfort, and flexible timings. Get a dedicated vehicle for personal, family, and corporate transportation needs."
  },
  {
    "name": "Cheap Belgaum to Hubli Cab",
    "description": "Book Cheap Belgaum to Hubli Cab with affordable fares, reliable service, and quality vehicles. Enjoy budget-friendly travel options without compromising safety, comfort, and convenience."
  },
  {
    "name": "Best Belgaum to Hubli Cab Service",
    "description": "Choose the Best Belgaum to Hubli Cab Service offering premium vehicles, experienced chauffeurs, competitive pricing, and dependable travel solutions for every journey requirement."
  },
  {
    "name": "Online Belgaum to Hubli Cab Booking",
    "description": "Complete Online Belgaum to Hubli Cab Booking with quick reservations, instant confirmation, transparent pricing, and multiple vehicle options. Enjoy easy and convenient taxi booking anytime."
  },
  {
    "name": "Belgaum to Hubli Taxi Fare",
    "description": "Check Belgaum to Hubli Taxi Fare with affordable packages, fixed pricing, and multiple cab options. Select the right vehicle according to your travel requirements and budget."
  },
  {
    "name": "24/7 Belgaum to Hubli Cab Service",
    "description": "Get 24/7 Belgaum to Hubli Cab Service with round-the-clock availability, professional drivers, clean vehicles, and reliable transportation support for urgent and planned travel."
  }
],
"tableData": [
  ["Belgaum to Hubli Cab", "Belgaum to Hubli Taxi"],
  ["Belgaum to Hubli Cab Service", "Belgaum to Hubli Taxi Service"],
  ["Belgaum to Hubli One Way Cab", "Belgaum to Hubli Cab Booking"],
  ["Belgaum to Hubli Car Rental", "Belgaum to Hubli Outstation Cab"],
  ["Belgaum to Hubli Airport Cab", "Belgaum to Hubli Airport Taxi"],
  ["Belgaum to Hubli Innova Crysta Cab", "Belgaum to Hubli Ertiga Cab"],
  ["Belgaum to Hubli Sedan Cab", "Belgaum to Hubli Round Trip Cab"],
  ["Belgaum to Hubli Private Taxi", "Cheap Belgaum to Hubli Cab"],
  ["Best Belgaum to Hubli Cab Service", "Online Belgaum to Hubli Cab Booking"],
  ["Belgaum to Hubli Taxi Fare", "24/7 Belgaum to Hubli Cab Service"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Hubli Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service offers comfortable Belgaum to Hubli cab services with experienced drivers, well-maintained vehicles, and convenient travel options for business and personal journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Belgaum",
    WhyChoosedescription: "Get easy pickup from Belgaum Airport, Railway Station, hotels, homes, offices, and nearby areas with direct drop at any location in Hubli."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other vehicles based on your comfort and travel requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Smooth Travel",
    WhyChoosedescription: "Our professional chauffeurs are familiar with the Belgaum to Hubli route and ensure safe, punctual, and comfortable journeys."
  },
  {
    WhyChooseheading: "One Way & Round Trip Cabs",
    WhyChoosedescription: "Book a one-way taxi or select a round-trip cab package according to your schedule and travel needs."
  },
  {
    WhyChooseheading: "Affordable Taxi Service",
    WhyChoosedescription: "Travel with transparent pricing, competitive fares, and flexible booking options without hidden charges."
  },
  {
    WhyChooseheading: "Ideal for Business & Personal Travel",
    WhyChoosedescription: "Our Belgaum to Hubli cabs are suitable for office visits, airport transfers, family trips, medical travel, and local transportation."
  },
  {
    WhyChooseheading: "24/7 Cab Booking Support",
    WhyChoosedescription: "Book your Belgaum to Hubli cab anytime with quick confirmation and dedicated customer assistance."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Hubli Cab Service?",
    answer: "Yes, we provide reliable one-way and round-trip cab services from Belgaum to Hubli with comfortable vehicles and professional drivers."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Hubli?",
    answer: "Yes, one-way taxi services are available with convenient pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Hubli travel?",
    answer: "We offer Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUVs, and other comfortable vehicles."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup and drop services are available from Belgaum Airport, Railway Station, hotels, and residential locations."
  },
  {
    question: "Is Belgaum to Hubli cab service available 24/7?",
    answer: "Yes, our taxi services are available 24 hours a day for your preferred travel timing."
  },
  {
    question: "Can I book a return cab from Hubli to Belgaum?",
    answer: "Yes, return and round-trip cab services are available with flexible travel schedules."
  },
  {
    question: "Are toll and parking charges included in the cab fare?",
    answer: "Toll charges, parking fees, state taxes, and other applicable charges are generally billed separately unless included in the confirmed quotation."
  },
  {
    question: "Is this cab service suitable for family and corporate travel?",
    answer: "Yes, our Belgaum to Hubli taxi service is suitable for families, business travelers, airport transfers, and personal trips."
  },
  {
    question: "Can I book a cab for Hubli airport travel?",
    answer: "Yes, we provide comfortable taxi services for Hubli airport transfers and nearby destinations."
  },
  {
    question: "How can I book a Belgaum to Hubli Cab?",
    answer: "Share your pickup location, Hubli destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ganesh Desai",
    feedback: "The Belgaum to Hubli cab service was comfortable and reliable. The driver arrived on time, the vehicle was clean, and the journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Patil",
    feedback: "We booked a cab for our family travel and had a great experience. The service was affordable, professional, and completely hassle-free.",
    rating: 5
  }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Hubli Cab",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-hubli-cab.webp",
  "description":
    "Book Belgaum to Hubli Cab with Belgaum Taxi Service for safe, comfortable, and affordable taxi services. We provide one-way and round-trip cabs from Belgaum to Hubli with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport transfers, business travel, and outstation journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-hubli-cab"
  }
};






    return (
        <div>



<Helmet>
  <title>Belgaum to Hubli Cab | One Way Taxi Service | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Hubli Cab with Belgaum Taxi Service for reliable one-way and round-trip taxi services. Get affordable cabs from Belgaum to Hubli with Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport transfers, business trips, and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="belgaum to hubli taxi, belgaum to hubli taxi fare, Hubli airport to belgaum taxi fare, Hubli to belgaum cab, Hubli to belgaum taxi, Hubli to belgaum taxi fare, Belgaum to Hubli Cab, Belgaum to Hubli Taxi, Belgaum to Hubli Cab Service, Belgaum to Hubli Taxi Service, Belgaum to Hubli One Way Cab, Belgaum to Hubli Cab Booking, Belgaum to Hubli Car Rental, Belgaum to Hubli Outstation Cab, Belgaum to Hubli Airport Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtohublicab;